export const getCurrentCoordinates = () => {
  if (!navigator.geolocation) {
    return Promise.reject(new Error('Geolocation is not supported by this browser'));
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        resolve({
          lat: coords.latitude,
          long: coords.longitude,
        });
      },
      (error) => {
        reject(new Error(error.message || 'Unable to fetch current location'));
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  });
};